import { create } from 'zustand';

interface AuthState {
  token: string | null;
  isAuthenticated: boolean;
  login: (token: string) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  token: localStorage.getItem('terravision_token'),
  isAuthenticated: !!localStorage.getItem('terravision_token'),

  login: (token) => {
    localStorage.setItem('terravision_token', token);
    set({ token, isAuthenticated: true });
  },

  logout: () => {
    localStorage.removeItem('terravision_token');
    set({ token: null, isAuthenticated: false });
  },
}));
